export default __webpack_public_path__ + "static/media/link.b92a9600.svg";